export default __webpack_public_path__ + "static/media/enamad.cefb0444.png";